module.exports = __webpack_public_path__ + "img/logo1.fa8813f3.png";